import React, { useEffect, useState } from "react";
import axios from "axios";

function ModalSolicitacoesAditivos({ projetoId, onClose }) {
  const [aditivos, setAditivos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("Token");
    axios
      .get(`/api/aditivos/${projetoId}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setAditivos(res.data || []);
      })
      .catch(() => setAditivos([]))
      .finally(() => setLoading(false));
  }, [projetoId]);

  return (
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      style={{ background: "#00000099" }}
      role="dialog"
    >
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content rounded-4 shadow-lg border-0 bg-white p-4">
          <div className="modal-header border-0 pb-0">
            <h5 className="modal-title">Solicitações de Aditivo</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>

          <div
            className="modal-body"
            style={{ maxHeight: "60vh", overflowY: "auto" }}
          >
            {loading ? (
              <div>Carregando...</div>
            ) : aditivos.length === 0 ? (
              <div>Nenhuma Solicitação encontrada.</div>
            ) : (
              <div className="row g-3">
                {aditivos.map((ad) => {
                  const statusColor =
                    {
                      aprovado: "success",
                      rejeitado: "danger",
                      pendente: "warning",
                    }[ad.status] || "secondary";

                  const isValor = ad.tipo === "valor";

                  return (
                    <div className="col-12" key={ad.id}>
                      <div
                        className={`card border-0 text-white bg-${statusColor} shadow-sm`}
                      >
                        <div className="card-body">
                          <div className="d-flex justify-content-between mb-2">
                            <h6 className="card-title mb-0">
                              {ad.status.charAt(0).toUpperCase() +
                                ad.status.slice(1)}
                            </h6>
                            <small>
                              {ad.data_criacao
                                ? new Date(ad.data_criacao).toLocaleDateString()
                                : "-"}
                            </small>
                          </div>
                          <div className="mb-1">
                            <strong>Tipo:</strong> {isValor ? "Valor" : "Prazo"}
                          </div>
                          <div className="mb-1">
                            <strong>Valor:</strong>{" "}
                            {ad.valor ? `R$ ${ad.valor}` : "-"}
                          </div>
                          <div className="mb-1">
                            <strong>Prazo:</strong>{" "}
                            {ad.prazo ? `${ad.prazo} dias` : "-"}
                          </div>
                          {ad.descricao_pedido && (
                            <div className="mb-1">
                              <strong>Justificativa do Pedido:</strong>{" "}
                              {ad.descricao_pedido}
                            </div>
                          )}
                          {ad.descricao_decisao && (
                            <div
                              className="mt-2"
                              style={{ whiteSpace: "pre-line" }}
                            >
                              <strong>Justificativa da Recusa:</strong>{" "}
                              {ad.descricao_decisao}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ModalSolicitacoesAditivos;
